import { createNanoEvents } from 'nanoevents';
import Vue from 'vue';
import _ from 'lodash';
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { injectService } from '@/inversify.config';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
class CommentService {
    constructor() {
        this._isDialogOpen = false;
        this.emitter = createNanoEvents();
        this.commentConfig = {
            docId: '',
            isCommentEditable: false,
            dataType: 'PATENT',
        };
    }
    get isDialogOpen() {
        return this._isDialogOpen;
    }
    open(config) {
        this.close();
        this.commentConfig = config;
        Vue.nextTick(() => {
            this._isDialogOpen = true;
        });
        return this.emitter;
    }
    close() {
        this._isDialogOpen = false;
        this.emitter.emit('close', this.commentConfig.commentsList);
        this.commentConfig = {
            docId: '',
            isCommentEditable: false,
            dataType: 'PATENT',
        };
        this.emitter.events = {};
    }
}
export const commentService = new CommentService();
class PatentEditCommentService {
    constructor() {
        this.openedId = null;
    }
    static Dialog() {
        return import('@/presentation/components/folders/EditCommentsDialog.vue');
    }
    open({ patent, canEdit }) {
        const openId = _.get(patent, 'PATENT_ID');
        if (this.openedId === openId) {
            return Promise.resolve();
        }
        else {
            this.close();
        }
        const spaceService = injectService(SpaceService);
        const folderService = injectService(FolderService);
        ptDialogAutoMounterManager.update(PatentEditCommentService.Dialog, {
            patentId: openId,
            patent,
            canEdit,
            workspaceId: spaceService.spaceInfo.space_id,
            folderId: folderService.folderInfo.folder_id,
        });
        this.openedId = openId;
        return ptDialogAutoMounterManager.openAsPromise(PatentEditCommentService.Dialog);
    }
    close() {
        ptDialogAutoMounterManager.unregister(PatentEditCommentService.Dialog);
        this.openedId = null;
        return Promise.resolve();
    }
}
export const patentEditCommentService = new PatentEditCommentService();
